import { render, staticRenderFns } from "./Sixt.vue?vue&type=template&id=48a84a78&scoped=true&"
import script from "./Sixt.vue?vue&type=script&lang=js&"
export * from "./Sixt.vue?vue&type=script&lang=js&"
import style0 from "./Sixt.vue?vue&type=style&index=0&id=48a84a78&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a84a78",
  null
  
)

export default component.exports